/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
exports.SelectOption = function SelectOption(_a) {
    var children = _a.children, active = _a.active, native = _a.native, value = _a.value, focused = _a.focused, disabled = _a.disabled, onMouseMove = _a.onMouseMove, onSelect = _a.onSelect;
    if (native) {
        return (React.createElement("option", { value: value, selected: active, disabled: disabled }, children));
    }
    return (React.createElement("button", { onClick: disabled && !active ? undefined : onSelect, type: "button", value: value, tabIndex: -1, onMouseMove: onMouseMove, className: classnames("m-select-option", {
            "m-select-isActive": active,
            "m-select-isFocused": focused,
            "m-select-isDisabled": disabled
        }) }, children));
};
exports.SelectOption.propTypes = {
    active: PropTypes.bool,
    native: PropTypes.bool,
    value: PropTypes.any,
    focused: PropTypes.bool,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func,
    onMouseMove: PropTypes.func
};